import { Button, Modal } from "antd"
import TimeLogForm from "components/timenotes/timer/time-log-form"
import { usePagePermissions } from "hooks/permissions.hooks"
import { useState } from "react"

interface Props extends React.ComponentProps<typeof Button> {
  onCloseWithChange?(): void
}

export function TimesheetBulkTimeLogButton(props: Props) {
  const [visible, setVisible] = useState(false)
  const [didLogTimeWhenOpen, setDidLogTimeWhenOpen] = useState(false)

  const { permissions } = usePagePermissions()

  // if can not set other people time logs -> dont allow bulk modal at all
  //if (!permissions?.setTimeLogUser) {
  //  return null
  //}

  const refreshTimesheetOnCloseIfNeeded = () => {
    if (didLogTimeWhenOpen && props.onCloseWithChange) {
      props.onCloseWithChange()

      setDidLogTimeWhenOpen(false)
    }
  }

  return (
    <>
      <Button
        onClick={() => setVisible((v) => !v)}

        {...props}
      >
        Log multiple entries
      </Button>

      <Modal
        width={1100}
        visible={visible}
        onCancel={() => {
          refreshTimesheetOnCloseIfNeeded()
          setVisible(false)
        }}

        title="Log multiple time entries at once"
        footer={null}
        destroyOnClose
      >
        <TimeLogForm 
          mode="manual"
          enableBulkMode
          enableUsersAccountSelect

          // mark the fact the user tried to log the time and refresh is needed
          onSubmit={() => {
            setDidLogTimeWhenOpen(true) 
          }}
        />

      </Modal>
    </>
  )
}